<template>
  <div class="adb2c row no-gutters flex-column flex-lg-row align-items-md-center align-items-end">
    <div class="col-auto" v-if="!isAuthenticated">
      <router-link :to="`/${$i18n.locale}/mydtm/home`" class="button-ghost primary small">MyDTM</router-link>
    </div>
    <div class="col-auto">
      <div class="main-menu__item" :class="{ 'hover': winWidth < 1160 }">
        <div class="text-uppercase text-align--right">
          <span class="main-menu__languagename">
            <router-link :to="`/${$i18n.locale}/mydtm/home`" v-if="isAuthenticated">
              <div class="avatar d-flex align-items-center">
                <div class="font-small pr-2 text-primary">{{ username }}</div>
                <div class="avatar__image"></div>
              </div>
            </router-link>
            <a href="#" @click="signIn" v-if="!isAuthenticated">
              <div class="avatar">
                <div class="avatar__image"></div>
              </div>
            </a>
          </span>
        </div>
        <div class="main-menu__subnav" v-if="isAuthenticated">
          <div class="main-menu__subnavitem text-uppercase">
            <router-link :to="`/${$i18n.locale}/mydtm/home`" class="main-menu__subnavlink">MyDTM</router-link>
          </div>
          <div class="main-menu__subnavitem text-uppercase">
            <a href="https://grid.dtm.com/api/auth/azure?redirectUrl=https://grid.dtm.com&policy=b2c_1a_signup_signin" target="_blank" class="main-menu__subnavlink">MyDTM Grid</a>
          </div>
          <div class="main-menu__subnavitem text-uppercase">
            <router-link :to="`/${$i18n.locale}/mydtm/preferences`" class="main-menu__subnavlink">
              {{ $t('common.preferences') }}
            </router-link>
          </div>
          <div class="main-menu__subnavitem text-uppercase">
            <a class="main-menu__subnavlink" @click="editProfile">{{ $t('common.profile') }}</a>
          </div>
          <div class="main-menu__subnavitem text-uppercase">
            <a href="#" @click="signOut" class="main-menu__subnavlink">{{ $t('common.logout') }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Adb2c',
  components: {},
  props: {},
  data () {
    return {
      loading: false,
      winWidth: 0
    };
  },
  computed: {
    isAuthenticated () {
      return this.$msal.isAuthenticated;
    },
    username () {
      return this.$msal.username;
    }
  },
  methods: {
    async signIn () {
      await this.$msal.signIn();
    },
    async signOut () {
      await this.$msal.signOut();
    },
    async editProfile () {
      await this.$msal.editProfile();
    },
    resize (values) {
      this.winWidth = values[0];
    }
  },
  mounted () {
    // watch window resize
    this.unwatchResize = this.$store.watch(() => this.$store.getters['scroll/resize'], resize => {
      // set headerScrolled true/false if threshold is reached
      this.resize(resize);
    });
  },
  created () {}
};
</script>

<style lang="scss">
.adb2c {
  .main-menu__item {
    padding-bottom: 5px;
  }
  .avatar {
    padding: 0 $gap;
    position: relative;
  }
  .avatar__image {
    width: 32px;
    height: 32px;
    background: #eee;
    border-radius: 100%;
    overflow: hidden;
    transition: all .3s;
    position: relative;
    display: inline-block;
    &:before, &:after {
      content: '';
      position: absolute;
      left: 50%;
      top: 50%;
      width: 10px;
      height: 10px;
      border-radius: 100%;
      background: rgba(0, 0, 0, 0.2);
      transform: translate(-50%, -100%);
    }
    &:after {
      width: 14px;
      height: 10px;
      border-radius: 100% 100% 0 0;
      transform: translate(-50%, 10%);
    }
  }
  &:hover {
    .avatar__image {
      background: #ccc;
    }
  }
}
@media (max-width: map-get($grid-breakpoints, 'lg')) {
  .adb2c {
    .main-menu__item {

    }
  }
}
@media (max-width: map_get($grid-breakpoints, 'md')) {
  .adb2c {
    padding-top: $gap;
    .avatar {
      padding: $gap;
      transform: translate($gap * 2, 0);
    }
    .button-ghost {
      margin-right: $gap * 2;
    }
    .main-menu__subnav {

    }
  }
}
</style>
